import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material'
import { ReactNode } from 'react'

interface ConfirmDialogProps {
    open: boolean
    title: string
    message: string | ReactNode
    confirmText?: string
    cancelText?: string
    onConfirm: () => void
    onCancel: () => void
    confirmColor?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
    loading?: boolean
}

export const ConfirmDialog = ({
    open,
    title,
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    onConfirm,
    onCancel,
    confirmColor = 'primary',
    loading = false
}: ConfirmDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    padding: '8px',
                    minWidth: '400px'
                }
            }}
        >
            <DialogTitle sx={{ 
                fontSize: '1.25rem', 
                fontWeight: 600,
                paddingBottom: '8px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText 
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: '0.95rem'
                    }}
                >
                    {typeof message === 'string' ? (
                        <span dangerouslySetInnerHTML={{ __html: message }} />
                    ) : (
                        message
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: '16px 24px' }}>
                <Button 
                    onClick={onCancel}
                    disabled={loading}
                    sx={{ 
                        textTransform: 'none',
                        color: 'text.secondary',
                        fontWeight: 500
                    }}
                >
                    {cancelText}
                </Button>
                <Button 
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmColor}
                    disabled={loading}
                    sx={{ 
                        textTransform: 'none',
                        fontWeight: 500,
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }}
                >
                    {loading ? 'Processando...' : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}